import { type ImageTransform } from '@sr/types/content/image';

export type ImageDimensions = Pick<ImageTransform, 'width' | 'height'>;
export type ImageSize = number | readonly [width: number, height: number];
export type ImageVariant = { size: ImageDimensions; descriptor: string };

const getDimensions = (size: ImageSize): ImageDimensions =>
  typeof size === 'number' ? { width: size } : { width: size[0], height: size[1] };

/** Converts explicit sizes to width candidates and selects the fallback size. */
export const resolveImageSizes = ({
  variants,
  fallbackSize,
}: {
  variants: readonly ImageSize[];
  fallbackSize?: ImageSize;
}) => {
  if (variants.length === 0) {
    throw new Error('Image variants must contain at least one size.');
  }

  const resolvedVariants = variants.map((size) => {
    const dimensions = getDimensions(size);

    return { size: dimensions, descriptor: `${dimensions.width}w` };
  });
  const resolvedFallbackSize =
    fallbackSize === undefined ? resolvedVariants[0].size : getDimensions(fallbackSize);

  return { resolvedVariants, resolvedFallbackSize };
};
